import { QueryEntity } from '@datorama/akita';
import { ProjectsState } from './projects.store';

export class ProjectsQuery extends QueryEntity<ProjectsState> {
}
